import { render, staticRenderFns } from "./MotivoDialog.vue?vue&type=template&id=63637a11"
import script from "./MotivoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MotivoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports